<template>
  <el-dialog
    :title="title + '二维码'"
    append-to-body
    destroy-on-close
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="420px"
    custom-class="enterpriseQrcodeDialog"
  >
    <div class="code-container">
      <div ref="qrcode"></div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  import { getEnterpriseLink } from 'api/request'
  export default {
    data() {
      return {
        title: '',
        visible: false
      }
    },
    watch: {
      visible (val) {
        if (!val) {
          Object.assign(this.$data, this.$options.data.call(this))
        }
      },
    },
    methods: {
      show(data) {
        const { id, name } = data
        this.title = name
        this.visible = true
        this.getLink(id)
   
      },
      async getLink(enterpriseId) {
        const result = await getEnterpriseLink({ enterpriseId })
        if (result && result.link) {
          this.$nextTick(() => {
            this.$refs.qrcode.innerHTML = ''
            const qrcodeEl = this.$refs.qrcode
            let qrcode = new QRCode(qrcodeEl, {
              // 第一个参数是组件的id值
              text: result.link, // 生成二维码的文本
              width: 200,
              height: 200,
              colorDark: "#000000", // 二维码色
              colorLight: "#ffffff", // 二维码背景色
              correctLevel: QRCode.CorrectLevel.H // 容错等级
            })
          })
        }
      },
      /*取消*/
      cancel () {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    }
  }
</script>

<style scoped lang="scss">
  .code-container{
    width: 100%;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog-footer{
    text-align: center;
  }
  /deep/.enterpriseQrcodeDialog{
    .el-dialog__body{
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
    .el-dialog__footer{
      padding-bottom: 15px;
    }
  }
</style>
